import classNames from 'classnames/bind';

import styles from './S01.module.scss';

import background from '../../../assets/images/products/oneday/s01/background.jpg';
import product from '../../../assets/images/products/oneday/s01/product.png';

const cx = classNames.bind(styles);

const S01 = () => {
  return (
    <div className={cx('container')} style={{ backgroundImage: `url(${background})` }}>
      <div className={cx('limiter')}>
        <h2 className={cx('title')}>귀리를 통으로 우려내 진한 곡물향을 그대로!</h2>
        <p className={cx('text')}>100% 국내산 원료로 안심하고 드실 수 있는 고소하고 깔끔한 풀무원 하루귀리!</p>
      </div>
      <img className={cx('product')} src={product} alt="풀무원 퓨어" />
    </div>
  );
};

export default S01;
